import {isTouchDevice} from "./helpers";

const $html = $('html');

if(isTouchDevice()) {
    $html.removeClass('no-touch');
}
